import { AxiosInstance } from 'axios';
import { axiosInstance } from './axios-instance';
import { AuthError } from './auth-api';

export interface ProfileData {
  first_name: string;
  last_name: string;
  email: string;
  phone_number?: string;
  description: string;
  gender: string;
  email_notifications_enabled?: boolean;
}

export interface ProfileResponse extends ProfileData {
  id: string;
  is_active: boolean;
  is_verified: boolean;
}

// Класс для работы с API профиля
export class ProfileApi {
  private api: AxiosInstance;

  constructor(api: AxiosInstance = axiosInstance) {
    this.api = api;
  }

  // Метод для получения данных профиля
  async getProfile(): Promise<ProfileResponse> {
    try {
      const response = await this.api.get<ProfileResponse>('/api/user/profile/');
      return response.data;
    } catch (error: any) {
      console.error('ProfileApi: Error getting profile:', error);
      if (error.response) {
        throw {
          detail: error.response.data.detail || 'Ошибка получения данных профиля',
          code: error.response.data.code,
          status_code: error.response.status
        } as AuthError;
      }
      throw { detail: 'Ошибка сети' } as AuthError;
    }
  }

  // Метод для обновления профиля
  async updateProfile(data: ProfileData): Promise<ProfileResponse> {
    try {
      const response = await this.api.put<ProfileResponse>('/api/user/profile/', data);
      return response.data;
    } catch (error: any) {
      console.error('ProfileApi: Error updating profile:', error);
      if (error.response) {
        throw {
          detail: error.response.data.detail || 'Ошибка обновления профиля',
          code: error.response.data.code,
          status_code: error.response.status
        } as AuthError;
      }
      throw { detail: 'Ошибка сети' } as AuthError;
    }
  }
}

export default new ProfileApi();